/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
import React from "react"
import styled from "styled-components"
import Video from "../Video"
import WistiaVideo from "./WistiaVideo"

const VideoPlayerWrapper = styled.div`
  .wrapper {
    ${props => props.shadow ? `box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5) !important;` : null}
  }
`

export default React.forwardRef(({ url, width, shadow, thumbnail, className, noPlayButton, disabled, ABTest, ...props }, ref) => {
    const regex = /wistia.co\w+/g
    let wistia = false
    if (url) {
        wistia = url.match(regex)
    }

    return (
        <VideoPlayerWrapper  {...props} shadow={shadow} className={`player-wrapper ${className ? className : null}`}>
            <div className="wrapper">
                {wistia ? (
                    <WistiaVideo
                        videoId={url.slice(
                            url.lastIndexOf("/") + 1,
                            url.lastIndexOf(".") > url.lastIndexOf("/")
                                ? url.lastIndexOf(".") : url.length
                        )}
                        thumbnail={thumbnail}
                        noPlayButton={noPlayButton}
                        disabled={disabled}
                        ABTest={ABTest}
                        ref={ref}
                        {...props}
                    />
                ) : (
                    <Video
                        key="video"
                        videoSource={url}
                        thumbnail={thumbnail}
                        width="100%"
                        height="100%"
                    />
                )}
            </div>
        </VideoPlayerWrapper>
    )
})